import DueDiligenceCalendarContainer from './containers/DueDiligenceCalendarContainer'

export default DueDiligenceCalendarContainer
